module.exports = __webpack_public_path__ + "img/competencies_swiper_13.21f3d089.jpg";